import React from 'react';
import { Switch, Route } from "react-router-dom";
import RestaurantHome from "./Home/RestaurantHome";
import RestaurantDetail from "./Detail/RestaurantDetail";

function Restaurant(props) {
    return (
        <Switch>  
            <Route path={`${props.match.url}`} exact component={RestaurantHome}/>
            <Route path={`${props.match.url}/:id`} exact component={RestaurantDetail}/>
        </Switch>
    )
}

export default Restaurant;
                                                            